// extracted by mini-css-extract-plugin
export default {"iconButton":"BackIconButton_iconButton__LT4pQ","icon":"BackIconButton_icon__7JSC8"};